import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../../index";
import { Button, Spinner } from "react-bootstrap";
import { getProducts } from "../../../http/productAPI";

const LoadMoreButton = observer(({ }) => {
  const { product } = useContext(Context);
  const { page, pageCount, isLoading, selectedFolder, products, requestBodyFilter } = product;

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    if (nextPage > pageCount) return;

    product.setLoading(true);

    try {
      const data = await getProducts(
        selectedFolder.id,
        nextPage,
        20,
        requestBodyFilter
      );

      // Добавляем полученные товары к текущим
     // product.setProducts([...products, ...data.products]);
    product.setProducts([...product.products, ...data.products]);

      // Обновляем номер страницы
      product.setPage(nextPage);
    } catch (error) {
      console.error("Ошибка при загрузке следующей страницы:", error);
    } finally {
      product.setLoading(false);
    }
  };

  // Не показывать кнопку, если мы уже на последней странице
  if (page >= pageCount-1) return null;

  return (
    <div className="d-flex justify-content-center my-4">
      <Button variant="outline-dark" className="me-lg-2 rounded-4 align-items-center" onClick={handleLoadMore} disabled={isLoading}>
        {isLoading ? (
          <>
            <Spinner size="sm" animation="border" className="me-2" />
            Загрузка...
          </>
        ) : (
          "Показать ещё"
        )}
      </Button>
    </div>
  );
});

export default LoadMoreButton;
